(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jsonpath"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["jsonpath", "axios"], factory);
	else if(typeof exports === 'object')
		exports["AsyncValidator"] = factory(require("jsonpath"), require("axios"));
	else
		root["Peace"] = root["Peace"] || {}, root["Peace"]["AsyncValidator"] = factory(root["jsonpath"], root["_"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__7__) {
return 